import { Panel } from "./Panel";
import { LoadContext } from "../../../utils";
import { Game } from '../../../game';
import { Focusable, InteractiveWrapper, Switch, Button } from '../../../ui';


export class Dwell extends Panel
{
    private switch:Switch;

    public static preload() {
        LoadContext.current.add('Settings', './assets/accessibility/Settings{size}.json');
        Switch.preload();
    }

    constructor( game:Game )
    {
        super(
            game,
            "Switch Access",
            {
                title: "CYB_Panel_Dwell",
                explain: 'CYB_Panel_DwellSettings',
                settings: 'CYB_Panel3_DwellSelected',
            },
            {width: 504, height: 195},
            true
        );
        // const icon:Sprite = new Sprite( LoadContext.current.getSpritesheet('Settings').textures['icon_closedcaptions']);
        // icon.position.set( this.icon_x, this.icon_y );
        // this.addChild( icon );

        this.switch = new Switch();
        this.switch.position.set( 175, 135 );
        this.updateToMatchSetting();

        this.switch.on( "switchChanged", (newValue:boolean)=>{
            this.game.vo.stop();
            this.game.settings.showRestArea.value = newValue;
            const eventName: string = newValue ? "dwell_activation_on" : "dwell_activation_off";
            this.game.logEvent("change_setting", eventName);
            this.playSwitchVO( this.switch );
        });
        this.disposables.add(new InteractiveWrapper(this.switch, {
            onHover: () => {
                this.playSwitchHover( this.switch );
            },
            onTap: () => {},
        }));
        this.addChild( this.switch );
    }

    getFocusItems():Focusable[]
    {
        let items = super.getFocusItems();
        return items.concat( [this.switch] );
    }

    updateToMatchSetting()
    {
        super.updateToMatchSetting();
        this.switch.isOn = this.game.settings.showRestArea.value;
    }

    destroy()
    {
        super.destroy();
    }
}